import { BookingsState } from "~/store/bookings/bookings.types"

const state = ():BookingsState => ({
  data: {},
  meta: {},
  filters: {}
})

export default state
